$(function() {
	// append popup holder
	if( $('.edit-popup, .show-popup').length > 0 ) {
		$('body').append('<div id="popup"><div id="popup-container"></div></div>');
	}


	// load popup
	$('body').on('click', '.edit-popup, .show-popup', function(){
		var popup = $('#popup');
		var popup_container = $('#popup-container');
		var url = $(this).attr('href');

		popup.show();

		center_popup();

		popup_container.html('<span class="popup-loading">Loading...</span>');
		popup_container.load(url + ' #popup-form');

		return false;
	});


	// close popup
	function close_popup(){
		$('#popup-container').html('');
		$('#popup').hide();
	}

	function center_popup(){
		// center popup
		var w = $(window).width();
		if( $('#sidebar').length > 0 ) {
			w -= $('#sidebar').width();
		}

		$('#popup').css('left', w/2);
	}

	if( $('#popup').length ) {
		$(window).resize(center_popup);
	}



	// close popup
	$('body').on('click', '#popup .close-popup', function(){ close_popup(); return false; });


	// submit
	$('body').on('submit', '#popup #popup-form', function(){
		var data = $(this).serializeArray();
		var url = $(this).attr('action');
		var id = url.replace(/.*\//, '');
		var that = $(this);
		var isValid = true;

		if (that.data('should-validate')) {
			isValid = window[that.data('validate-method')]();
		}

		if (!isValid) {
			alert('Please fill the fields.');
			$(this).find('.field-error').first().focus();
			return false;
		}

		$('#popup-container').html('<span class="popup-loading">Loading...</span>');

		$.ajax({
			url: url,
			data: data,
			type: "POST",
			success: function(response) {
				if (that.data('submit-callback')) {
					window[that.data('submit-callback')](response);
					return;
				}

				var resp = $(response);
				var selector = 'tr[data-id=' + id + ']';
				$('#main table ' + selector).html( resp.find(selector).html() );
				close_popup();
			}
		});
		return false;
	});
});
